import React, { useState, useEffect } from 'react';
import { API_CONFIG } from './../../config'; 

const CREATE_USER_ENDPOINT = `${API_CONFIG.BASE_URL}${API_CONFIG.ENDPOINTS.USERAPPINSTALL}`;

const AppInstallUsers = () => {
  const [users, setUsers] = useState([]);
  const [totalUsers, setTotalUsers] = useState(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchUsers();
  }, []);

  const fetchUsers = async () => {
    try {
      // Your PHP API endpoint URL
      const response = await fetch(CREATE_USER_ENDPOINT);
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      const data = await response.json();
      
      if (data.success) {
        setUsers(data.data);
        setTotalUsers(data.count);
        setLoading(false);
      } else {
        throw new Error(data.message || 'Failed to fetch users');
      }
    } catch (err) {
      setError('Failed to fetch users: ' + err.message);
      setLoading(false);
    }
  };

  // Function to adjust time by adding 5 hours 30 minutes
  const adjustTime = (dbDate) => {
    const date = new Date(dbDate);
    // Add 5 hours and 30 minutes
    date.setHours(date.getHours() + 5);
    date.setMinutes(date.getMinutes() + 30);
    return date;
  };

  // Format date for display - Updated format: 09-07-2026 , 01:07 PM
  const formatDate = (date) => {
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    
    let hours = date.getHours();
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const ampm = hours >= 12 ? 'PM' : 'AM';
    
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    const formattedHours = String(hours).padStart(2, '0');
    
    return `${day}-${month}-${year} , ${formattedHours}:${minutes} ${ampm}`;
  };

  // Handle print
  const handlePrint = () => {
    window.print();
  };

  if (loading) {
    return (
      <div style={styles.container}>
        <div style={{...styles.totalBanner, textAlign: 'center'}}>
          <h2>Loading users...</h2>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div style={styles.container}>
        <div style={{...styles.totalBanner, background: '#e74c3c'}}>
          <h2>{error}</h2>
        </div>
      </div>
    );
  }

  return (
    <div style={styles.container}>
      <div style={styles.totalBanner}>
        <h2>Total Registered Users: {totalUsers}</h2>
      </div>

      <button 
        className="no-print" 
        onClick={handlePrint} 
        style={styles.printButton}
      >
        Print Report
      </button>

      <table style={styles.table}>
        <thead>
          <tr>
            <th style={styles.th}>SL</th>
            <th style={styles.th}>User ID</th>
            <th style={styles.th}>Registration Time (Adjusted +5h 30m)</th>
          </tr>
        </thead>
        <tbody>
          {users.map((user, index) => {
            const adjustedDate = adjustTime(user.date);
            const displayDate = formatDate(adjustedDate);
            
            return (
              <tr key={user.id}>
                <td style={styles.td}>{index + 1}</td>
                <td style={{...styles.td, ...styles.userId}}>{user.userId}</td>
                <td style={styles.td}>{displayDate}</td>
              </tr>
            );
          })}
        </tbody>
      </table>

     
    </div>
  );
};

// Styles object
const styles = {
  container: {
    maxWidth: '900px',
    margin: 'auto',
    background: 'white',
    padding: '20px',
    borderRadius: '8px',
    boxShadow: '0 2px 10px rgba(0,0,0,0.1)'
  },
  totalBanner: {
    background: '#2c3e50',
    color: 'white',
    padding: '10px',
    marginBottom: '20px',
    borderRadius: '5px'
  },
  printButton: {
    padding: '10px 20px',
    cursor: 'pointer',
    marginBottom: '20px'
  },
  table: {
    width: '100%',
    borderCollapse: 'collapse',
    marginTop: '20px'
  },
  th: {
    padding: '12px',
    borderBottom: '1px solid #ddd',
    textAlign: 'left',
    background: '#2c3e50',
    color: 'white'
  },
  td: {
    padding: '12px',
    borderBottom: '1px solid #ddd',
    textAlign: 'left'
  },
  userId: {
    fontWeight: 'bold',
    color: '#e74c3c',
    fontFamily: 'monospace',
    fontSize: '1.1em'
  }
};

export default AppInstallUsers;